import React from 'react';

// Pacer Logo component - inverted to white for dark backgrounds
export const PacerLogo = ({ className = '', width = 100, height = 32 }) => {
  return (
    <img 
      src="https://customer-assets.emergentagent.com/job_a979a285-4d78-46ad-9f70-2b1f5df03385/artifacts/3ylpbqk0_Pacer%20logo%20black.png"
      alt="Pacer"
      width={width}
      height={height}
      className={`invert brightness-0 invert ${className}`}
      style={{ filter: 'invert(1) brightness(100)' }}
    />
  );
};

export default PacerLogo;
